import { tx } from "@/i18n/tx";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, XCircle } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [status, setStatus] = useState("checking");
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) { setStatus("error"); return; }
    api.post("/auth/verify-email", { token }).then(() => setStatus("ok")).catch(() => setStatus("error"));
  }, [token]);

  return (
    <div className="anima-backdrop min-h-screen flex items-center justify-center px-7">
      <div className="w-full max-w-md text-center" data-testid="verify-email">
        {status === "checking" && <p className="font-serif text-2xl text-anima-muted italic">{tx("Verifica in corso...")}</p>}
        {status === "ok" && (
          <>
            <CheckCircle2 size={52} className="text-anima-sagedeep mx-auto mb-4" />
            <h1 className="font-serif text-4xl text-anima-ink mb-3">{tx("Email confermata")}</h1>
            <p className="text-anima-muted mb-8">{tx("Grazie. Il tuo indirizzo email e stato verificato.")}</p>
            <button onClick={() => navigate("/app")} className="w-full rounded-full bg-anima-sagedeep text-anima-ivory py-4 font-medium">{tx("Vai alla home")}</button>
          </>
        )}
        {status === "error" && (
          <>
            <XCircle size={52} className="text-anima-muted mx-auto mb-4" />
            <h1 className="font-serif text-4xl text-anima-ink mb-3">{tx("Collegamento non valido")}</h1>
            <p className="text-anima-muted mb-8">{tx("Il collegamento potrebbe essere scaduto o gia utilizzato. Puoi richiederne uno nuovo dal tuo profilo.")}</p>
            <button onClick={() => navigate("/app")} className="w-full rounded-full bg-anima-sagedeep text-anima-ivory py-4 font-medium">{tx("Vai alla home")}</button>
          </>
        )}
      </div>
    </div>
  );
}
